import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setVoiceAdd } from "../../redux/reducers/voiceAdd/voiceAddReducer";
import "./voiceAdd.scss";

const MicIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 14a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v5a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.7V21h2v-3.3A7 7 0 0 0 19 11h-2z" />
  </svg>
);

export const isVoiceFabRaised = (gym, gymConfig) =>
  Boolean(
    gym &&
      gym.subscriptionPlan &&
      gym.subscriptionPlan.id != 1 &&
      ((gymConfig &&
        gymConfig.gates &&
        gymConfig.gates.enabled &&
        gymConfig.gates.accessBy === "RFIDCards") ||
        (gymConfig &&
          gymConfig.manageMemberships &&
          gymConfig.manageMemberships.scannerCheckIn) ||
        (gymConfig &&
          gymConfig.manageMemberships &&
          gymConfig.manageMemberships.expiringToday))
  );

export const VoiceAddFab = () => {
  const dispatch = useDispatch();
  const enabled = useSelector(
    (state) =>
      Boolean(state.features && state.features.gymFeaturesObject && state.features.gymFeaturesObject.voiceAdd)
  );
  const voiceAdd = useSelector((state) => state.voiceAdd) || {};
  const gymState = useSelector((state) => state.gym) || {};
  const gymConfig = gymState.gymConfig;
  const gym = gymState.gym;
  if (!enabled) return null;

  const notifyVisible = isVoiceFabRaised(gym, gymConfig);
  const active = Boolean(
    voiceAdd.sessionId ||
      (voiceAdd.drafts && voiceAdd.drafts.length) ||
      (voiceAdd.messages && voiceAdd.messages.length)
  );

  return (
    <button
      type="button"
      className={`voice-add-fab${voiceAdd.open ? " is-open" : ""}${
        active ? " is-active" : ""
      }${notifyVisible ? " is-raised" : ""}`}
      aria-label={voiceAdd.open ? "Hide voice add" : "Add with voice"}
      aria-pressed={Boolean(voiceAdd.open)}
      onClick={() => dispatch(setVoiceAdd({ open: !voiceAdd.open }))}
    >
      <MicIcon />
    </button>
  );
};
